import { useCallback } from "react";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const useIsGPTAvailable = () => {
    const { bWindow } = useBrowserAPI();
    return useCallback(() => {
        var _a, _b, _c, _d;
        return ((_a = bWindow.googletag) === null || _a === void 0 ? void 0 : _a.apiReady) &&
            typeof ((_b = bWindow.googletag) === null || _b === void 0 ? void 0 : _b.pubads) === "function" &&
            typeof ((_d = (_c = bWindow.googletag) === null || _c === void 0 ? void 0 : _c.pubads()) === null || _d === void 0 ? void 0 : _d.setTargeting) === "function";
    }, [bWindow]);
};
